import React, { FC, memo, useMemo } from 'react'
import Plyr from 'plyr-react'
import { IPlayerProps } from '../types'
import 'plyr-react/plyr.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'plyr/dist/plyr.css'

/** Плеер (аудио, видео) */
const Player: FC<IPlayerProps> = (props) => {
  const { source, options } = props

  const settings = useMemo(() => {
    return {
      source, // https://github.com/sampotts/plyr#the-source-setter
      options, // https://github.com/sampotts/plyr#options
    }
  }, [source, options])

  return <Plyr {...settings} />
}

export default memo(Player)
